import type { ProductGatewayMovementChannelMatch } from '@/modules/cashIn/types/productGatewayCashIn.type';

/**
 * Busca el ID del primer movimiento que coincida con el canal dado.
 * Si no hay coincidencia por canal, intenta con el campo `comment` usando el fallback indicado.
 * @param movements - Lista de movimientos del product-gateway.
 * @param channel - Canal de transacción a buscar (ej. 'INSWITCH', 'WOMPI').
 * @param options - Opciones adicionales. `commentFallback`: valor alternativo para buscar en `comment`.
 * @returns El ID del movimiento encontrado, o undefined si no hay coincidencia.
 */
export function findFirstMovementIdByChannel(
  movements: ReadonlyArray<ProductGatewayMovementChannelMatch> | undefined,
  channel: string,
  options?: { commentFallback?: string }
): number | undefined {
  if (!movements?.length) {
    return undefined;
  }

  const normalized = channel.trim();
  const fallback = options?.commentFallback?.trim();

  const byChannel = movements.find(
    (m) => m.transactionChannel?.trim() === normalized
  );
  if (byChannel) {
    return byChannel.id;
  }

  if (fallback) {
    const byComment = movements.find((m) => m.comment?.trim() === fallback);
    if (byComment) {
      return byComment.id;
    }
  }

  return undefined;
}
